
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
import ListTable from './ListTable'
// import SaldoKas from './SaldoKas'
import EntryDialog from './EntryDialog'
const components = {
  layout,
  ListTable,
  // SaldoKas,
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `Finance/CashAccountSummarize/loadingState`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  reload: `Finance/CashAccountSummarize/fetchData`,
})

methods.addNewRecord = function() {
  this.$refs.EntryDialog.show()
}

methods.reloadKas = function() {
  this.$refs.SaldoKas.reload()
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Laporan Keuangan`)
  this.$store.commit(`set_breadcrumb`, [ `Kas`, `Transaksi` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<style scoped>
</style>

<template>
  <layout>
    <!-- <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Saldo Kas

          <div class="pull-right">
            <ButtonL icon="repeat" color="default" @click="reloadKas" />
          </div>
        </template>
        <template #content>
          <SaldoKas ref='SaldoKas' />
        </template>
      </BlockTable>
    </Row> -->

    <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Transaksi Kas

          <div class="pull-right">
            <ButtonL icon="repeat" color="default" @click="reload" />
            <ButtonL text="Kredit / Debit" color="primary" @click="addNewRecord" />
          </div>
        </template>
        <template #content>
          <ListTable />
        </template>
      </BlockTable>
    </Row>

    <EntryDialog ref="EntryDialog"></EntryDialog>
  </layout>
</template>